export const isElementHidden = (element: HTMLElement) => {
  if (element.parentElement && isElementHidden(element.parentElement)) {
    return true
  }

  return element.hidden
}
